import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import BrokersCreate from "./BrokersCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function ListadoBrokers() {
  const { user } = useContext(AuthContext);
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [brokers, setBrokers] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [datos, setDatos] = useState({ razonSocial: "", contacto: "", email: "", telefono: "" });
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    axios
      .get(URL_BROKERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBrokers = response.data;
        setBrokers(allBrokers);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editBroker(event) {
    event.preventDefault();
    const URL_BROKERS_EDIT = `${process.env.REACT_APP_URL_BROKERS}/${idEdit}`;
    axios
      .patch(
        URL_BROKERS_EDIT,
        {
          name,
          ...datos,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Broker',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.response?.data?.message || "Something went wrong!",
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, broker = {}) {
        setName(name);
        setDatos({
          razonSocial: broker.razonSocial || "",
          contacto: broker.contacto || "",
          email: broker.email || "",
          telefono: broker.telefono || "",
        });
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <div className="container col-sm-11">
        { user.menuBrokers ? (
          <>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-user-tie" /></span>
                Brokers
              </h3>
              <p className="page-subtitle">{t("Catálogo de brokers aduanales")}</p>
            </div>
          </div>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-list" style={{ color: "#2563eb" }} /> {t("Registros")} <span>{brokers.length}</span></div>
          </div>
          <div className="row">
            {
              <div className="col-md-8 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="stat-chip mb-2" style={{ display: "inline-flex" }}>
                      <i className="fas fa-exclamation-circle" style={{ color: "#b45309" }} /> {t("Sin datos completos")}
                      <span>{brokers.filter((b) => !b.razonSocial || !b.email || !b.telefono).length}</span>
                    </div>
                    <Table
                      size="sm"
                      hover
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">{t("Nombre")}</th>
                          <th className="tituloTabla">{t("Razón social")}</th>
                          <th className="tituloTabla">{t("Contacto")}</th>
                          <th className="tituloTabla">{t("Correo")}</th>
                          <th className="tituloTabla">{t("Teléfono")}</th>
                          <th className="tituloTabla">{t("Editar")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {brokers
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td className="td-strong">{a.name}</td>
                                  <td className={a.razonSocial ? undefined : "td-muted"}>{a.razonSocial || t("Falta")}</td>
                                  <td className={a.contacto ? undefined : "td-muted"}>{a.contacto || "—"}</td>
                                  <td className={a.email ? undefined : "td-muted"}>{a.email || "—"}</td>
                                  <td className={a.telefono ? undefined : "td-muted"}>{a.telefono || "—"}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      title={t("Editar")}
                                      onClick={(e) => jalaInfo(a._id, a.name, a)}
                                    >
                                      <i className="fas fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_BROKERS
                                      }
                                    />
                              
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-4 col-sm-12">
              <div className="card">
                <div className="card-body">
                  <BrokersCreate />
                </div>
              </div>
            </div>
          </div>
          </>
        ) : undefined}
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Broker</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          {[
            ["razonSocial", "Razón social"],
            ["contacto", "Contacto"],
            ["email", "Correo"],
            ["telefono", "Teléfono"],
          ].map(([k, l]) => (
            <div key={k} className="mt-2">
              <Label className="mr-sm-2">{t(l)}</Label>
              <Input
                type={k === "email" ? "email" : "text"}
                value={datos[k]}
                onChange={(e) => {
                  const v = e.target.value;
                  setDatos((d) => ({ ...d, [k]: v }));
                }}
              />
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editBroker}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoBrokers;
